import { doc, $, $$, RM } from "./util.js";

export function initSnake() {
  const snakes = $$("[data-snake]").map((el) => ({
    el,
    svg: $("svg.path", el),
    path: $("path.track", el),
    dot: $("circle.dot", el),
    len: 0,
    vis: false,
    raf: 0,
    t0: 0,
  })).filter((s) => s.svg && s.path && s.dot);
  if (!snakes.length) return;

  const placeDot = (s, k) => {
    if (!s.len) return;
    const p = s.path.getPointAtLength(s.len * k);
    s.dot.setAttribute("cx", p.x);
    s.dot.setAttribute("cy", p.y);
  };

  const layout = () => {
    snakes.forEach((s) => {
      const box = s.el.getBoundingClientRect();
      if (!box.width) return;
      const pts = $$(".step .no", s.el).map((n) => {
        const r = n.getBoundingClientRect();
        return { x: r.left + r.width / 2 - box.left, y: r.top + r.height / 2 - box.top };
      });
      if (!pts.length) return;
      const mobile = pts.length > 1 && Math.abs(pts[0].x - pts[1].x) < 5;
      let d;
      if (mobile) {
        d = "M8 " + (pts[0].y - 20) + " L8 " + (pts[pts.length - 1].y + 60);
      } else {
        d = "M" + pts[0].x + " " + pts[0].y;
        for (let i = 1; i < pts.length; i++) {
          const a = pts[i - 1], b = pts[i], my = (a.y + b.y) / 2;
          d += " C" + a.x + " " + (my + 60) + " " + b.x + " " + (my - 60) + " " + b.x + " " + b.y;
        }
      }
      s.svg.setAttribute("viewBox", "0 0 " + box.width + " " + box.height);
      s.path.setAttribute("d", d);
      s.len = s.path.getTotalLength();
      placeDot(s, RM ? 1 : 0);
    });
  };

  const tick = (s) => {
    const loop = (now) => {
      s.raf = 0;
      if (!s.vis || doc.hidden) return;
      if (!s.t0) s.t0 = now;
      let k = ((now - s.t0) % 7000) / 7000;
      k = k < 0.5 ? 2 * k * k : 1 - Math.pow(-2 * k + 2, 2) / 2;
      placeDot(s, k);
      s.raf = requestAnimationFrame(loop);
    };
    return loop;
  };

  if ("IntersectionObserver" in window) {
    snakes.forEach((s) => {
      const loop = tick(s);
      new IntersectionObserver((es) => {
        s.vis = es[0].isIntersecting;
        if (s.vis && !RM && !s.raf) {
          if (!s.len) layout();
          s.raf = requestAnimationFrame(loop);
        }
      }).observe(s.el);
      doc.addEventListener("visibilitychange", () => {
        if (!doc.hidden && s.vis && !RM && !s.raf) s.raf = requestAnimationFrame(loop);
      });
    });
  }

  layout();
  let st;
  window.addEventListener("resize", () => {
    clearTimeout(st);
    st = setTimeout(layout, 150);
  });
  window.addEventListener("load", layout);
  if (doc.fonts && doc.fonts.ready) doc.fonts.ready.then(layout);
}
